(() => {
  'use strict';

  const mapElement = document.getElementById('trison-b2b-presence-map');
  if (!mapElement || mapElement.dataset.trisonMapReady === 'true') return;

  const LEAFLET_VERSION = '1.9.4';
  const leafletCss = `https://unpkg.com/leaflet@${LEAFLET_VERSION}/dist/leaflet.css`;
  const leafletJs = `https://unpkg.com/leaflet@${LEAFLET_VERSION}/dist/leaflet.js`;

  const locations = [
    {
      city: 'Dhoraji, Gujarat',
      country: 'India',
      role: 'Registered office & sourcing base',
      coordinates: [21.73367, 70.449915],
      marker: 'IN'
    },
    {
      city: 'Düsseldorf',
      country: 'Germany',
      role: 'European market coordination',
      coordinates: [51.2277, 6.7735],
      marker: 'DE'
    }
  ];

  const addStylesheet = () => {
    if (document.querySelector('link[data-trison-leaflet-css]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = leafletCss;
    link.dataset.trisonLeafletCss = 'true';
    document.head.appendChild(link);
  };

  const loadLeaflet = () => new Promise((resolve, reject) => {
    if (window.L && typeof window.L.map === 'function') {
      resolve(window.L);
      return;
    }

    const current = document.querySelector('script[data-trison-leaflet-js]');
    if (current) {
      current.addEventListener('load', () => resolve(window.L), { once: true });
      current.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = leafletJs;
    script.async = true;
    script.dataset.trisonLeafletJs = 'true';
    script.addEventListener('load', () => resolve(window.L), { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

  const showFallback = () => {
    mapElement.innerHTML = '<div class="trison-map-fallback"><p>Our operating presence connects Dhoraji, Gujarat, India with Düsseldorf, Germany. Location cards below provide the city-level context.</p></div>';
  };

  const initialise = (L) => {
    if (!L || typeof L.map !== 'function') {
      showFallback();
      return;
    }

    const map = L.map(mapElement, {
      attributionControl: true,
      scrollWheelZoom: false,
      zoomControl: true,
      dragging: true,
      keyboard: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap contributors</a>',
      maxZoom: 19
    }).addTo(map);

    const route = locations.map((location) => location.coordinates);
    L.polyline(route, {
      color: '#aa8750',
      weight: 2,
      opacity: 0.82,
      dashArray: '7 9',
      interactive: false
    }).addTo(map);

    locations.forEach((location) => {
      const marker = L.marker(location.coordinates, {
        icon: L.divIcon({
          className: 'trison-map-marker-shell',
          html: `<span class="trison-map-marker">${location.marker}</span>`,
          iconSize: [34, 34],
          iconAnchor: [17, 17]
        }),
        title: `${location.city}, ${location.country} — ${location.role}`
      }).addTo(map);

      marker.bindTooltip(`${location.city}, ${location.country}`, {
        className: 'trison-map-tooltip',
        direction: 'top',
        offset: [0, -17],
        opacity: 1
      });
    });

    map.fitBounds(L.latLngBounds(route), {
      padding: [58, 48],
      maxZoom: 4
    });

    window.setTimeout(() => map.invalidateSize(), 250);
    mapElement.dataset.trisonMapReady = 'true';
  };

  addStylesheet();
  loadLeaflet().then(initialise).catch(showFallback);
})();
